// 현재 로그인 회사의 테넌트 프리셋 (packages/tenant-config 공용). 컴포넌트에서는 this.$tenant 로 접근.
import { reactive } from 'vue';
import { resolveTenant, wardOf, wardByCode } from '../../packages/tenant-config';

const state = reactive({ tenant: resolveTenant(readCompany()) });

function readCompany() {
  try { return localStorage.getItem('company') || ''; } catch (e) { return ''; }
}

// 로그인 직후·라우트 이동 시 호출해 localStorage 의 company 와 동기화
export function refreshTenant() {
  const next = resolveTenant(readCompany());
  if (next.id !== state.tenant.id) state.tenant = next;
  return state.tenant;
}

export function currentTenant() { return state.tenant; }
export { wardOf, wardByCode };
export default state;
